export default "__VITE_ASSET__33na_FOa__"